//改大写功能
export function titleCase (str) {
    let temp = [];
    str = str.toLowerCase(); //全部转换为小写
    temp = str.split(" "); //用空格区分，分割存入数组
    for (let i = 0; i < temp.length; i++) {
      let str_temp = temp[i].charAt(0); //获取首字母
      str_temp = str_temp.toUpperCase(); //转换为大写
      temp[i] = temp[i].replace(temp[i].charAt(0), str_temp); //将首字母变换
    }
    str = temp.join(" ");
    return str;
}